import React, { useContext } from 'react';
import { MarkerContentProps, PinVariant } from '../Map.interface';
import PinContent from './PinContent';
import { OrderTarget } from '../../OrdersTable/interfaces/OrderStatus.interface';
import { AuthContext } from '../../../context/context';

const MarkerContent = ({
	marker,
	delivery,
	pickup,
	fleetBase,
	orderProduct,
	productStore,
	markerHovered,
	target,
}: MarkerContentProps) => {
	const { user } = useContext(AuthContext);

	switch (marker.variant) {
		case PinVariant.delivery:
			return (
				<PinContent
					countryCode={delivery?.deliveryCountryCode}
					address={delivery?.deliveryAddress}
					markerHovered={markerHovered}
				/>
			);
		case PinVariant.pickup: {
			const canShowPickupAddress =
				target === OrderTarget.transporter ||
				target === OrderTarget.admin ||
				target === OrderTarget.producer;

			if (canShowPickupAddress) {
				return (
					<PinContent
						countryCode={pickup?.pickupCountryCode}
						address={pickup?.pickupAddress}
						markerHovered={markerHovered}
					/>
				);
			}

			return (
				<PinContent orderProduct={orderProduct} markerHovered={markerHovered} />
			);
		}
		case PinVariant.fleet_base:
			return (
				<PinContent
					countryCode={fleetBase?.countryCode}
					address={fleetBase?.address}
					companyName={user?.company?.name}
					markerHovered={markerHovered}
				/>
			);
		case PinVariant.product_store:
			return (
				<PinContent productStore={productStore} markerHovered={markerHovered} />
			);
		default:
			return null;
	}
};

export default MarkerContent;
